@if (inputService.show) {
  <ng-container [formGroup]="inputService.formGroup">
    <mat-form-field appearance="outline">
      <mat-label>{{inputService.computedTitle | translate}}</mat-label>
      @if (inputService.inputConfig.hint) {
        <mat-hint>{{inputService.inputConfig.hint | translate}}</mat-hint>
      }
      @if (inputService.inputConfig.readOnly) {
        <input [required]='inputService.inputConfig.required' [matTooltip]='selectedLabel' matInput readonly type='text' [value]='selectedLabel'/>
      }
      <mat-select panelClass="multiselect-actions-panel" [required]='inputService.inputConfig.required' [matTooltip]='selectedLabel' [placeholder]="inputService.inputConfig.placeholder | translate" [formControlName]='inputService.formControlKey' (selectionChange)="selectionChange($event)" multiple>
        <mat-option class="action-option" disabled="disabled">
          <button mat-button color='accent' (click)="selectAll()">{{'Seleziona Tutti' | translate}}</button>
          <button mat-button color='accent' (click)="deselectAll()">{{'Deseleziona Tutti' | translate}}</button>
        </mat-option>
        <mat-divider></mat-divider>
        @for (selectOption of selectOptions; track selectOption) {
          <mat-option [value]='selectOption.value'>
            <span>{{selectOption.label | titlecase}}</span>
          </mat-option>
        }
      </mat-select>
      @if (!inputService.control.valid && inputService.errorMessage) {
        <mat-error>{{inputService.errorMessage | translate}}</mat-error>
      }
    </mat-form-field>
  </ng-container>
}